var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoringPref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9641_4266)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 0H0V9.16667H9.16667V0ZM5 1.66667H2.5V2.50001H4.16666V6.66667H4.99999L5 1.66667ZM2.5 7.50001V6.66668H6.66667V7.50001H2.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H10.8333V9.16667H20V0ZM18.3334 1.66667H12.5001V2.50001H18.3334V4.16667H19.1667V2.50001H18.3334L18.3334 1.66667ZM12.5 5.00001H13.3334V6.66667H12.5V5.00001ZM18.3334 4.16667L13.3334 4.16668L13.3334 5.00001L18.3334 5.00001V4.16667ZM12.5 6.66667L19.1667 6.66668V7.50001H12.5V6.66667Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 10.8333H0V20H9.16667V10.8333ZM6.6667 12.5H1.6667V13.3333H6.66666V15H7.49999V13.3333L6.66666 13.3333L6.6667 12.5ZM6.66668 15.8333H7.49999V17.5H6.66666L6.66668 15.8333L3.33335 15.8333V15L6.66666 15L6.66668 15.8333ZM1.66665 17.5L6.66666 17.5V18.3333H1.66665V17.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.8333H10.8333V20H20V10.8333ZM13.3334 12.5H12.5V15H13.3334V15.8333H17.5V19.1667H18.3334V12.5H17.5V15H13.3334L13.3334 12.5Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9641_4266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoringPref);
export default __webpack_public_path__ + "static/media/ScoringPref.958031b552ca081e330e1d71ea2e50dd.svg";
export { ForwardRef as ReactComponent };